var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.actual) + "/")]),
    _c("span", { staticStyle: { color: "red" } }, [
      _vm._v(_vm._s(_vm.inventory))
    ]),
    _vm._v("/"),
    _c("span", { staticStyle: { color: "red" } }, [
      _vm._v(_vm._s(_vm.valueNum))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }